import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import { debounce } from "lodash"

import { DesktopHeader } from "./DesktopHeader"
import { MobileHeader } from "./MobileHeader"
import { useHeaderContext } from "../../context/HeaderContext"

const HeaderWrapper = styled.div`
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;

  transition: ${props =>
    props.expanded
      ? "background-color 200ms ease, max-height 750ms ease"
      : "background-color 250ms ease 550ms, max-height 650ms ease"};

  background-color: ${props =>
    props.expanded ? props.theme.white : "transparent"};
  max-height: ${props => (props.expanded ? "55%" : "0")};
`

export const Header = ({ dark, useRosterFiltering = false }) => {
  const [showSubNav, setShowSubNav] = useState(false)
  const [showNav, setShowNav] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const { showSearch } = useHeaderContext()

  const scrollThreshold = 200

  useEffect(() => {
    const handleScroll = debounce(e => {
      if (!isScrolled & (window.scrollY > scrollThreshold)) {
        setIsScrolled(true)
      }

      if (isScrolled & (window.scrollY < scrollThreshold)) {
        setIsScrolled(false)
      }
    }, 20)

    window.addEventListener("scroll", handleScroll)

    return () => window.removeEventListener("scroll", handleScroll)
  })

  const isExpanded = showSubNav || showSearch || showNav

  const data = useStaticQuery(graphql`
    {
      allContentfulGlobal {
        edges {
          node {
            publicCategories {
              name
              subcategories {
                name
              }
              artist {
                name
              }
            }
          }
        }
      }
    }
  `)

  // The roster menu contains all public categories
  const categories = data.allContentfulGlobal.edges[0].node.publicCategories

  return (
    <HeaderWrapper
      dark={dark}
      expanded={useRosterFiltering || isExpanded || isScrolled}
      isScrolled={isScrolled}
    >
      <DesktopHeader
        theme={dark ? "dark" : "light"}
        publicCategories={categories}
        isExpanded={useRosterFiltering || showSubNav}
        useRosterFiltering={useRosterFiltering}
        isScrolled={isScrolled}
        onRosterButtonClick={() => setShowSubNav(!showSubNav)}
      />

      <MobileHeader
        theme={dark ? "dark" : "light"}
        publicCategories={categories}
        isExpanded={showSubNav}
        isModalShown={showNav || showSearch}
        useRosterFiltering={useRosterFiltering}
        isScrolled={isScrolled}
        onRosterButtonClick={() => setShowSubNav(!showSubNav)}
        onCloseClick={() => setShowNav(false)}
        onHamburgerClick={() => setShowNav(true)}
      />
    </HeaderWrapper>
  )
}
